<template>
  <div class="recommend-container">
    <!--    <TypeTab-->
    <!--      ref="TypeTab"-->
    <!--      :typeList="typeList"-->
    <!--      @tabChange="tabChange"-->
    <!--    ></TypeTab>-->
    <div class="reset flex align-center justify-center cs" @click="reset">
      <img class="reset-img" src="../assets/images/recommend/reset.png" />
      <span>换一波</span>
    </div>
    <div class="content">
      <div class="list">
        <agenda ref="agenda"></agenda>
        <!--        <Exhibition ref="Exhibition" v-show="nowType == 1"></Exhibition>-->
        <!--        <SweepingMonk-->
        <!--          @getMonkList="getMonkList"-->
        <!--          ref="SweepingMonk"-->
        <!--          v-show="nowType == 2"-->
        <!--        ></SweepingMonk>-->
        <div class="source">
          Powered by <span style="font-weight: bold">Horiz UniAI</span>
        </div>
        <div class="line"></div>
      </div>
      <div class="foot flex align-center justify-between">
        <div
          class="cancel flex align-center justify-center cs"
          @click="cancelAccept"
        >
          <img
            class="cancel-img cs"
            src="../assets/images/recommend/untj.png"
          />
          <span>我要取消推荐服务</span>
        </div>
        <div v-if="isLogin" class="score flex align-center justify-center">
          <span>推荐的内容您还满意吗？</span>
          <div
            class="star-box flex align-center justify-between"
            @mouseout="resetStar"
          >
            <img
              class="star-box-img cs"
              @mouseover="setTmpStar(item)"
              @click="setStar(item)"
              v-for="item in 5"
              :key="item"
              :src="
                item <= tmpStarNum
                  ? require('../assets/images/recommend/star.png')
                  : require('../assets/images/recommend/unstar.png')
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import TypeTab from "./common/type-tab/TypeTab";
import Agenda from "./recommend/Agenda";
// import Exhibition from "./recommend/Exhibition";
// import SweepingMonk from "./recommend/SweepingMonk";
import _ from "lodash";
import { mapState } from "vuex";
import Cookie from "js-cookie";

export default {
  name: "Recommend",
  components: {
    // TypeTab,
    Agenda,
    // Exhibition,
    // SweepingMonk,
  },
  data() {
    return {
      starNum: 0,
      tmpStarNum: 0,
      getStar: false,
      hasMonk: false,
      typeList: [
        {
          name: "议程推荐",
          type: "议程推荐",
        },
        {
          name: "展厅推荐",
          type: "展厅推荐",
        },
      ],
      nowType: 0,
    };
  },
  computed: mapState({
    userInfo: (state) => state.userInfo.info,
    tokenInfo: (state) => state.userInfo.token,
    isLogin: (state) => !!state.userInfo.token,
    AttendanceStatus: (state) => state.userInfo.AttendanceStatus,
  }),
  mounted() {
    //是否授权智能推荐
    let r = Cookie.get("accept_recommend");
    const smarketToken = this.tokenInfo.smarketToken || "";
    if (this.isLogin) {
      this.$api
        .GetRecommend()
        .then((res) => {
          if (res.result == 0) {
            this.acceptRecommend = res.content;
            Cookie.set("accept_recommend", res.content);
            if (smarketToken && this.acceptRecommend == 1) {
              this.$api.GetRecommendScore().then((res) => {
                this.starNum = res.content;
                this.tmpStarNum = res.content;
              });
            }
          }
        })
        .catch((err) => {
          this.acceptRecommend = 0;
        });
    } else {
      if (r == 1) {
        if (smarketToken && r == 1) {
          this.$api.GetRecommendScore().then((res) => {
            this.starNum = res.content;
            this.tmpStarNum = res.content;
          });
        }
      }
    }
    //this.getMonkList();
  },
  methods: {
    getMonkList(e) {
      this.$nextTick(() => {
        if (this.$refs.SweepingMonk.$data.list.length > 0) {
          this.typeList = [
            {
              name: "议程推荐",
              type: "议程推荐",
            },
            {
              name: "展厅推荐",
              type: "展厅推荐",
            },
            {
              name: "扫地僧推荐",
              type: "扫地僧推荐",
            },
          ];
        }
      });
    },
    setStar(e) {
      //埋码
      window._hw("send", "action", "index_recommend_score_click", {
        score: e,
      });
      this.$api
        .RecommendScore({
          score: e,
        })
        .then(() => {
          this.starNum = e;
        });
    },
    resetStar() {
      this.tmpStarNum = _.cloneDeep(this.starNum);
    },
    setTmpStar(e) {
      this.tmpStarNum = e;
    },
    cancelAccept() {
      //埋码
      window._hw("send", "action", "index_cancel_recommend_click");
      this.$emit("setAccept", 0);
      this.nowType = 0;
      // this.$refs.TypeTab.tabIndexChange(0);
    },
    reset() {
      //埋码 用户进入推荐弹窗-点击换一拨
      window._hw("send", "action", "index_recommend_change_click");
      this.$refs[
        ["agenda", "Exhibition", "SweepingMonk"][this.nowType]
      ].reset();
    },
    tabChange(e) {
      this.nowType = e;
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 992px) {
  .recommend-container {
    width: 1000px;
    height: auto;
    min-height: 371px;
    position: absolute;
    top: 0;
    //bottom: 0;
    right: 91px;
    background: #ffffff url("../assets/images/recommend/leftbg.png") no-repeat
      left bottom;
    background-size: 300px 200px;
    opacity: 1;
    border: 1px solid;
    border-image: linear-gradient(
        164deg,
        rgba(239, 239, 239, 1),
        rgba(235, 235, 235, 0)
      )
      1 1;
    filter: blur(undefinedpx);
    z-index: $z-index-foot;

    .reset {
      user-select: none;
      width: 110px;
      height: 32px;
      position: absolute;
      top: 22px;
      right: 25px;
      border-radius: 0 0 0 0;
      opacity: 1;
      border: 1px solid #b4251e;

      .reset-img {
        width: 15px;
        height: 14px;
        margin-right: 7px;
      }

      span {
        height: 24px;
        font-size: 16px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #b4251e;
        line-height: 24px;
      }
    }

    .content {
      padding-top: 50px;
      width: 100%;
      height: auto;
      min-height: 300px;

      .list {
        height: auto;
        min-height: 250px;
        width: 100%;
        padding-top: 20px;
        padding-right: 30px;
        padding-left: 30px;

        .source {
          width: 100%;
          height: 16px;
          margin-top: 19px;
          font-size: 14px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;

          color: #999999;
          line-height: 16px;
          text-align: right;
        }
      }
    }

    .foot {
      width: 100%;
      height: 50px;
      border-top: 1px solid rgba(192, 193, 197, 0.2);
      background: rgba(255, 255, 255, 0.6);
      .cancel {
        margin-left: 30px;
        width: auto;
        height: 100%;

        .cancel-img {
          width: 15px;
          height: 15px;
          margin-right: 8px;
        }

        span {
          font-size: 14px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;

          color: #999999;
        }
      }

      .score {
        width: auto;
        height: 100%;
        margin-right: 30px;

        span {
          height: 16px;
          font-size: 14px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;

          color: #999999;
          line-height: 16px;
        }

        .star-box {
          width: 127px;
          height: 14px;

          .star-box-img {
            width: 14px;
            height: 14px;
          }
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .recommend-container {
    width: 560px;
    height: 600px;
    overflow-y: auto;
    position: absolute;
    top: 0;
    right: 123px;
    background: #ffffff url("../assets/images/recommend/leftbg.png") no-repeat
      left bottom;
    background-size: 300px 200px;
    opacity: 1;
    border: 1px solid;
    border-image: linear-gradient(
        164deg,
        rgba(239, 239, 239, 1),
        rgba(235, 235, 235, 0)
      )
      1 1;
    filter: blur(undefinedpx);
    z-index: $z-index-foot;

    .reset {
      width: 165px;
      height: 48px;
      margin: 0 auto;
      margin-top: 25px;
      margin-bottom: 30px;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      border: 1px solid #b4251e;

      .reset-img {
        width: 23px;
        height: 21px;
        margin-right: 7px;
      }

      span {
        height: 24px;
        font-size: 20px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #b4251e;
        line-height: 24px;
      }
    }

    .content {
      width: 100%;
      .list {
        width: 100%;
        padding: 20px 0px 0 0px;

        .source {
          padding: 34px 30px 24px 34px;
          width: 100%;
          height: 25px;
          font-size: 22px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;

          color: #999999;
          line-height: 26px;
          text-align: right;
        }
        .line {
          width: 100%;
          height: 2px;
          margin-top: 20px;
          background: #bbbbbb;
          border-radius: 0px 0px 0px 0px;
          opacity: 0.24;
        }
      }
    }
    //
    //.content::-webkit-scrollbar {
    //  display: none; /*隐藏滚动条*/
    //}

    .foot {
      width: 100%;
      height: 140px;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .cancel {
        width: 100%;
        height: 24px;
        padding-right: 24px;
        justify-content: flex-end;

        .cancel-img {
          width: 22px;
          height: 22px;
          margin-right: 11px;
        }

        span {
          font-size: 22px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;

          color: #999999;
        }
      }

      .score {
        width: 100%;
        height: 26px;
        margin-top: 25px;
        justify-content: flex-end;

        span {
          height: 25px;
          margin-right: 28px;
          font-size: 22px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;

          color: #999999;
          line-height: 26px;
        }

        .star-box {
          width: 190px;
          height: 22px;
          margin-right: 29px;
          justify-content: space-between;

          .star-box-img {
            width: 21px;
            height: 21px;
          }
        }
      }
    }
  }
}
@media screen and (min-aspect-ratio: 84/90) and (max-aspect-ratio: 100/90) {
  .recommend-container {
    width: 560px;
    height: 450px;
    overflow-y: auto;
    position: absolute;
    top: 0;
    right: 90px;
    background: #ffffff url("../assets/images/recommend/leftbg.png") no-repeat
      left bottom;
    background-size: 300px 200px;
    opacity: 1;
    border: 1px solid;
    border-image: linear-gradient(
        164deg,
        rgba(239, 239, 239, 1),
        rgba(235, 235, 235, 0)
      )
      1 1;
    filter: blur(undefinedpx);
    z-index: $z-index-foot;
    .agenda-container {
      height: unset;
    }
  }
}
</style>
